import { ROLES } from '../../../Permission'
import { ColumnsType } from 'antd/es/table'
import { ColumnType } from 'antd/es/table/interface'
import { VendorUser } from './types'

export const filterColumns = (
  selectedRole: string,
  columns: ColumnsType<VendorUser>
) =>
  columns.filter((i: ColumnType<VendorUser>) => {
    switch (i.dataIndex) {
      case 'contract_categories':
        return (
          selectedRole !== ROLES.SALES_REPRESENTATIVE &&
          selectedRole !== ROLES.VENDOR_FINANCE_OFFICER
        )
      default:
        return true
    }
  })
